export const POST_CALL_RESULT = 'POST_CALL_RESULT';
export const POST_CALL_RESULT__SUCCESS = 'POST_CALL_RESULT__SUCCESS';
export const POST_CALL_RESULT__FAILURE = 'POST_CALL_RESULT__FAILURE';
export const POST_CALL_RESULT__RESET = 'POST_CALL_RESULT__RESET';

export const postCallResult = ({ formData }) => ({ type: POST_CALL_RESULT, formData });
export const resetCallResult = () => ({ type: POST_CALL_RESULT__RESET });
